import { HisInformationProcessResult } from "../../../../domain/his";

export class HisInformationProcessResultConverter {
  static toMessageText(processResult: HisInformationProcessResult) {
    if (!processResult || !processResult.errorResults || processResult.errorResults.length === 0) { return ""; }
    return processResult.errorResults.map(r => r.name + "情報").join("・") + "を取得できませんでした。";
  }
}
